import {
  Button,
  Card,
  ControlGroup,
  Elevation,
  Tag,
  Collapse,
  InputGroup,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost } from "../fns/util";
import { inject, observer } from "mobx-react";
import cogoToast from "cogo-toast";
import _ from "lodash";
import { withRouter } from "react-router";
import AsyncSelWrap from "../utils/AsyncSelWrap";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";

class SxSteps extends React.Component {
  state = {
    collapsed: true,
    sxLineItemSearching: false,
    sxLineItemSearchResults: [],
    sxLineItemSelectedItem: null,
    AEItemSearching: false,
    AEItemSearchResults: [],
    AEItemSelectedItem: null,
    isWaitingOnLineItem: false,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  search = async (
    string,
    searchResArray,
    isSearchingShowSpinner,
    selectedItem,
    apiUrl
  ) => {
    if (!string) {
      this.setState({
        [searchResArray]: [],
        [selectedItem]: null,
      });
      return;
    }
    try {
      this.setState({ [isSearchingShowSpinner]: true });
      let payload = { prefix: string || "" };
      let res = await apiCallPost(apiUrl, payload);
      let results = res;
      this.setState({
        [searchResArray]: results,
        [isSearchingShowSpinner]: false,
      });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details."
      );
      console.log(err);
    }
  };
  renderAsyncSearchers = (
    tagText,
    placeHolderText,
    stateSearchingKey,
    stateSearchResultsKey,
    stateSelectedItemKey,
    searchApiUrl
  ) => {
    return (
      <ControlGroup>
        <Tag large minimal>
          {tagText}
        </Tag>
        <AsyncSelWrap
          disabled={this.props.isBusy || this.state.isWaitingOnLineItem}
          placeholder={placeHolderText}
          searching={this.state[stateSearchingKey]}
          items={this.state[stateSearchResultsKey].map((each) => {
            if (stateSearchingKey === "sxLineItemSearching") {
              return {
                ...each,
                item: each.sxStepName,
                entityTypeString: each.specialisation,
                helper: each.schedulingTag,
              };
            } else {
              return {
                ...each,
                item: each.entityName,
                entityTypeString: _.truncate(each.description, { length: 20 }),
              };
            }
          })}
          selectedItem={null}
          update={(string) =>
            this.search(
              string,
              stateSearchResultsKey,
              stateSearchingKey,
              stateSelectedItemKey,
              searchApiUrl
            )
          }
          onChange={(chosenItem) => {
            if (stateSearchingKey === "sxLineItemSearching") {
              this.props.onUpdate({
                sxSteps: [...this.props.data.sxSteps, chosenItem],
              });
            } else {
              this.props.onUpdate({
                adverseEvent: [
                  ...this.props.data.adverseEvent,
                  {
                    ...chosenItem,
                    event: chosenItem.entityName,
                    notes: "",
                    includeInDischarge: false,
                  },
                ],
              });
            }
          }}
        />
      </ControlGroup>
    );
  };
  renderSxStepsSearch = () => {
    return (
      <ControlGroup>
        {this.renderAsyncSearchers(
          "Add Surgical Steps",
          "Sx Steps",
          "sxLineItemSearching",
          "sxLineItemSearchResults",
          "sxLineItemSelectedItem",
          `/meta-sx/${this.props.authStore.prefix}/getSxSteps`
        )}
      </ControlGroup>
    );
  };
  renderAddedSteps = () => {
    if (!this.props.data.sxSteps) {
      return null;
    }
    if (!this.props.data.sxSteps.length) {
      return (
        <ControlGroup>
          {" "}
          <Tag large intent="warning" minimal>
            No surgical steps added yet
          </Tag>
        </ControlGroup>
      );
    }
    let ii = this.props.data.sxSteps;
    return ii.map((each, index) => {
      return <ControlGroup>{this.renderEachStep(each, index)}</ControlGroup>;
    });
  };
  renderAEs = () => {
    if (!this.props.data.adverseEvent) {
      return null;
    }
    if (!this.props.data.adverseEvent.length) {
      return (
        <ControlGroup>
          {" "}
          <Tag large intent="warning" minimal>
            No adverse events recorded.
          </Tag>
        </ControlGroup>
      );
    }
    let ii = this.props.data.adverseEvent;
    return ii.map((each, index) => {
      return (
        <ControlGroup>
          <Tag
            intent="danger"
            minimal
            large
            onRemove={() => {
              let ii = this.props.data.adverseEvent;
              ii.splice(index, 1);
              this.props.onUpdate({ adverseEvent: ii });
            }}
          >
            {each.event}
          </Tag>
          <Tag intent="danger" minimal large>
            Notes
          </Tag>
          <InputGroup
            value={each.notes}
            onChange={(event) => {
              let ii = this.props.data.adverseEvent;
              ii[index].notes = event.target.value;
              this.props.onUpdate({ adverseEvent: ii });
            }}
          />
        </ControlGroup>
      );
    });
  };
  renderEachStep = (item, index) => {
    return (
      <div>
        <ControlGroup>
          <Tag minimal large intent="primary">
            {index + 1}
          </Tag>
          <Tag large intent="primary">
            {item.sxStepName}
          </Tag>
          <Button
            intent="danger"
            text="Remove"
            icon="trash"
            outlined
            onClick={() => {
              let ii = this.props.data.sxSteps;
              ii.splice(index, 1);
              this.props.onUpdate({ sxSteps: ii });
            }}
          />
        </ControlGroup>
        <br />
        {this.renderSxSubsteps(item, index)}
      </div>
    );
  };
  renderSxSubsteps = (item, index) => {
    let substeps = item.sxSubSteps;
    return substeps.map((each, idx) => {
      return <div>{this.renderEachSubstep(index, each, idx)}</div>;
    });
  };

  renderParamsForSubstep = (sxStepIndex, sxSubstep, sxSubstepIndex) => {
    let params = sxSubstep.parameters;
    return params.map((each, parameterIndex) => {
      if (
        _.split(each.options, ",")
          .map((t) => _.trim(t))
          .filter(Boolean).length
      ) {
        let optArray = _.split(each.options, ",")
          .map((t) => _.trim(t))
          .filter(Boolean);
        return (
          <div>
            <ControlGroup>
              <Tag minimal large intent={each.isDone ? "success" : "none"}>
                {each.paramName}
              </Tag>

              <SingleSelectWrapper
                items={optArray}
                selectedItem={each.chosenItem}
                onChange={(option) => {
                  let ii = this.props.data.sxSteps;
                  ii[sxStepIndex].sxSubSteps[sxSubstepIndex].parameters[
                    parameterIndex
                  ].chosenItem = option;
                  ii[sxStepIndex].sxSubSteps[sxSubstepIndex].parameters[
                    parameterIndex
                  ].isDone = true;
                  this.props.onUpdate({ sxSteps: ii });
                }}
              />
              <Tag minimal large>
                Notes for {each.paramName}
              </Tag>
              <InputGroup
                value={each.notes}
                onChange={(event) => {
                  let ii = this.props.data.sxSteps;
                  ii[sxStepIndex].sxSubSteps[sxSubstepIndex].parameters[
                    parameterIndex
                  ].notes = event.target.value;
                  this.props.onUpdate({ sxSteps: ii });
                }}
              />
              <Tag
                intent={each.isDone ? "success" : "warning"}
                interactive
                minimal
                large
                icon={each.isDone ? "tick" : "cross"}
                onClick={() => {
                  let ii = this.props.data.sxSteps;
                  ii[sxStepIndex].sxSubSteps[sxSubstepIndex].parameters[
                    parameterIndex
                  ].isDone = !each.isDone;
                  if (each.isDone) {
                    ii[sxStepIndex].sxSubSteps[sxSubstepIndex].parameters[
                      parameterIndex
                    ].chosenItem = null;
                  }
                  this.props.onUpdate({ sxSteps: ii });
                }}
              >
                {each.isDone ? "Done" : "Not Done"}
              </Tag>
            </ControlGroup>
          </div>
        );
      } else {
        return (
          <ControlGroup>
            <Tag minimal large>
              {each.paramName}
            </Tag>{" "}
            <Tag minimal large>
              Notes for {each.paramName}
            </Tag>
            <InputGroup
              value={each.notes}
              onChange={(event) => {
                let ii = this.props.data.sxSteps;
                ii[sxStepIndex].sxSubSteps[sxSubstepIndex].parameters[
                  parameterIndex
                ].notes = event.target.value;
                this.props.onUpdate({ sxSteps: ii });
              }}
            />
            <Tag
              intent={each.isDone ? "success" : "warning"}
              interactive
              minimal
              large
              icon={each.isDone ? "tick" : "cross"}
              onClick={() => {
                let ii = this.props.data.sxSteps;
                ii[sxStepIndex].sxSubSteps[sxSubstepIndex].parameters[
                  parameterIndex
                ].isDone = !each.isDone;
                this.props.onUpdate({ sxSteps: ii });
              }}
            >
              {each.isDone ? "Done" : "Not Done"}
            </Tag>
          </ControlGroup>
        );
      }
    });
  };
  renderEachSubstep = (sxStepIndex, sxSubstep, sxSubstepIndex) => {
    return (
      <Card style={{ marginBottom: "15px", padding: "5px" }}>
        <ControlGroup vertical>
          <ControlGroup>
            <Tag
              intent={sxSubstep.isDone ? "success" : "warning"}
              large
              minimal
            >
              {sxSubstepIndex + 1}
            </Tag>
            <Tag intent={sxSubstep.isDone ? "success" : "warning"} large>
              {sxSubstep.step}
            </Tag>{" "}
            <Tag
              intent={sxSubstep.isDone ? "success" : "warning"}
              interactive
              large
              icon={sxSubstep.isDone ? "endorsed" : "cross"}
              onClick={() => {
                sxSubstep.isDone = !sxSubstep.isDone;
                let ii = this.props.data.sxSteps;
                ii[sxStepIndex].sxSubSteps[sxSubstepIndex] = sxSubstep;
                this.props.onUpdate({ sxSteps: ii });
              }}
            >
              {sxSubstep.isDone ? "Done" : "Not Done"}
            </Tag>
          </ControlGroup>{" "}
          <ControlGroup>
            <Tag minimal large>
              Notes for {sxSubstep.step}
            </Tag>
            <InputGroup
              value={sxSubstep.notes}
              onChange={(event) => {
                sxSubstep.notes = event.target.value;
                let ii = this.props.data.sxSteps;
                ii[sxStepIndex].sxSubSteps[sxSubstepIndex] = sxSubstep;
                this.props.onUpdate({ sxSteps: ii });
              }}
            />
          </ControlGroup>
          {sxSubstep.parameters && sxSubstep.parameters.length ? (
            <>
              {this.renderParamsForSubstep(
                sxStepIndex,
                sxSubstep,
                sxSubstepIndex
              )}
            </>
          ) : null}
        </ControlGroup>
      </Card>
    );
  };
  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          <Card elevation={Elevation.FOUR}>
            <Tag large intent="primary" style={{ marginBottom: "10px" }}>
              Surgical Notes
            </Tag>
            <Tag large minimal>
              {this.props.data.sxSteps
                .map((each) => each.sxStepName)
                .join(", ")}
            </Tag>
            <Button
              icon="double-chevron-down"
              outlined
              onClick={() => this.setState({ collapsed: false })}
            />
          </Card>{" "}
        </Collapse>
        <Collapse isOpen={!this.state.collapsed}>
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large fill intent="primary">
                Surgical Notes
              </Tag>{" "}
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: true })}
              />
            </ControlGroup>
            <div
              style={
                this.props.canEdit
                  ? {}
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                    }
              }
            >
              <br />
              {this.renderSxStepsSearch()}
              {this.renderAddedSteps()}
              <br />
              {this.renderAsyncSearchers(
                "Record Adverse Events",
                "Adverse Events",
                "AEItemSearching",
                "AEItemSearchResults",
                "AEItemSelectedItem",
                `/meta-sx/${this.props.authStore.prefix}/SxAdverseEventMaster/search`
              )}
              {this.renderAEs()}
            </div>
          </Card>
        </Collapse>
      </>
    );
  };

  render() {
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(SxSteps)));
